<template>
  <div class="agent">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'agent',
  }
</script>

<style scoped lang="scss">
  .agent-code{
    width: 100%;
    height: 100%;
  }
</style>

